import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  labelContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  treeItemRoot: {
    '& div': {
      backgroundColor: 'transparent !important',
    },
  },
}));

export default useStyles;
